import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { SafeUrl } from '@angular/platform-browser';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';




import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { InicioComponent } from './inicio/inicio.component';
import { MenuComponent } from './menu/menu.component';
import { CabeceraComponent } from './cabecera/cabecera.component';
import { FormularioComponent } from './formulario/formulario.component'
//import { PreguntaComponent } from './pregunta/pregunta.component'
import { NormasComponent } from './normas/normas.component'
import { ActividadesComponent } from './actividades/actividades.component'
import { FormularioActividadesComponent } from './actividades/formularioactividades.component';
import { ErrorComponent } from './404/error.component'
import { PerfilComponent } from './perfil/perfil.component';

import { FormularioNormasComponent } from './normas/formularionormas.component';
import { FormularioNormasPenalComponent } from './normas/formularionormaspenal.component';
import { FormularioNormasMaestrasComponent } from './normas/formularionormasmaestras.component';

import { InventarioNormasComponent } from './inventarionormas/inventarionormas.component';
import { FormularioBloqueComponent } from './inventarionormas/formulariobloque.component'
import { FormularioAreaComponent } from './inventarionormas/formularioarea.component'
import { FormularioModuloComponent } from './inventarionormas/formulariomodulo.component'
import { FormularioPermisosComponent } from './inventarionormas/formulariopermisos.component'

import { InventarioNormasPenalComponent } from './inventarionormaspenal/inventarionormaspenal.component';
import { FormularioBloquePenalComponent } from './inventarionormaspenal/formulariobloquepenal.component'
import { FormularioAreaPenalComponent } from './inventarionormaspenal/formularioareapenal.component'
import { FormularioModuloPenalComponent } from './inventarionormaspenal/formulariomodulopenal.component'
import { FormularioPermisosPenalComponent } from './inventarionormaspenal/formulariopermisospenal.component'

import { EvidenciasComponent } from './evidencias/evidencias.component'
import { EvidenciasINComponent } from './evidencias/evidenciasin.component'
import { EvidenciasVistaComponent } from './evidencias/evidenciasvista.component';
import { DragDropComponent } from './dragdrop/dragdrop.component'
import { CuestionarioComponent } from './cuestionario/cuestionario.component';
import { CuestionarioFullComponent } from './cuestionario/cuestionariofull.component';
import { CuestionariosComponent } from './cuestionario/cuestionarios.component';
import { FormularioRespuestasComponent } from './cuestionario/formulariorespuestas.component';
import { PreguntaComponent } from './cuestionario/pregunta.component';
import { RespuestaComponent } from './cuestionario/respuesta.component';
import { ModalEvidenciasComponent } from './cuestionario/modalevidencias.component';
import { ModalDocumentoComponent } from './cuestionario/modaldocumento.component';
import { ModalPreguntasComponent } from './cuestionario/modalpreguntas.component';
import { ModalModulosAfectadosComponent } from './normas/modalmodulosafectados.component';
import { ModalNormasMaestrasComponent } from './normas/modalnormasmaestras.component';
import { ModalEnlaceNormasComponent } from './normas/modalenlacenormas.component';
import { ModalEvidenciasMaestrasComponent } from './evidencias/modalevidenciasmaestras.component';
import { ModalEvidenciasAfectaPersonalComponent } from './evidencias/modalevidenciasafectapersonal.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuarioComponent } from './usuarios/usuario.component';
import { EmpresasComponent } from './empresas/empresas.component';
import { EmpresaComponent } from './empresas/empresa.component';
import { CentrosDeTrabajoComponent } from './centrosdetrabajo/centrosdetrabajo.component';
import { CentroDeTrabajoComponent } from './centrosdetrabajo/centrodetrabajo.component';
import { LicenciaComponent } from './licencias/licencia.component';
import { LicenciasComponent } from './licencias/licencias.component';

import { SubidaDeImagenes } from './subidaimagenes/subidaimagenes.component'

import { InstalacionesComponent } from './instalaciones/instalaciones.component';
import { FormularioInstalacionesComponent } from './instalaciones/formularioinstalaciones.component';
import { EquiposComponent } from './equipos/equipos.component';
import { FormularioEquiposComponent } from './equipos/formularioequipos.component';
import { TipoCentrosComponent } from './tipocentros/tipocentros.component';
import { FormularioTipoCentrosComponent } from './tipocentros/formulariotipocentros.component';
import { FormularioEvidenciasTipoCentrosComponent } from './tipocentros/formularioevidenciastipocentro.component';

import {FileUploadModule} from "ng2-file-upload/file-upload/file-upload.module";

import { FormularioEvidenciasComponent } from './evidencias/formularioevidencias.component'
import { FormularioEvidenciasPenalComponent } from './evidencias/formularioevidenciaspenal.component'
import { FormularioEvidenciasMaestrasComponent } from './evidencias/formularioevidenciasmaestras.component'

import { routing } from './app.routing'

import { UsuariosService } from './_services/usuarios.service'
import { EmpresasService } from './_services/empresas.service'
import { CentrosDeTrabajoService } from './_services/centrosdetrabajo.service'
import { LicenciasService } from './_services/licencias.service'
import { NormasService } from './_services/normas.service'
import { EvidenciasService } from './_services/evidencias.service'
import { AutentificacionService } from './_services/autentificacion.service'
import { SeguridadService } from './_services/seguridad.service'
import { MenuService } from './_services/menu.service'
import { CuestionarioService } from './_services/cuestionario.service'
import { GlobalEventsManager } from './_services/globaleventsmanager.service'
import {TextospredefinidosService} from './_services/textospredefinidos.service';
import {TiendaService} from './_services/tienda.service';

import { DataTableModule } from "angular2-datatable";
import { DataFilterPipe }   from './_models/data-filter.pipe';


//import { TooltipModule } from 'ng2-bootstrap/tooltip';
import { ModalModule } from 'ng2-bootstrap/modal';

import { TooltipModule } from 'primeng/primeng';

import {CalendarModule} from 'primeng/primeng';

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { ModalusuariosctComponent } from './modalusuariosct/modalusuariosct.component';

//import {ImageCropperComponent, CropperSettings} from 'ng2-img-cropper';
import {ImageCropperModule} from "ng2-img-cropper/index";
import { TextospredefinidosComponent } from './textospredefinidos/textospredefinidos.component';
import { FormulariotextosComponent } from './textospredefinidos/formulariotextos.component';
import { ModalevidenciainfoComponent } from './cuestionario/modalevidenciainfo.component';
import {DragulaModule} from 'ng2-dragula';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './_interceptors/request.interceptor';
import { HistorialnormasaccionesComponent } from './normas/historialnormasacciones.component';
import { ModaladminusuariosctsComponent } from './modaladminusuarioscts/modaladminusuarioscts.component';
import { ModalevidenciasempresasComponent } from './modalevidenciasempresas/modalevidenciasempresas.component';
import { ModalmoverevidenciaComponent } from './modalmoverevidencia/modalmoverevidencia.component';
import { ModalcomponentComponent } from './modalcomponent/modalcomponent.component';
import { ModalmovermoduloComponent } from './modalmovermodulo/modalmovermodulo.component';
import { EvidenciafiltrosComponent } from './evidenciafiltros/evidenciafiltros.component';
import { NormafiltrosComponent } from './normafiltros/normafiltros.component';
import { EvidenciasequitativasComponent } from './evidenciasequitativas/evidenciasequitativas.component';
import { ModalnormasempresasafectadasComponent } from './normas/modalnormasempresasafectadas.component';
import { Select2Module } from 'ng2-select2';
import { ModalformularioareaComponent } from './normas/modalformularioarea.component';
import { UsuariorolesComponent } from './usuarioroles/usuarioroles.component';
import { FormulariousuariorolesComponent } from './usuarioroles/formulariousuarioroles.component';
import { UsuariorolesappsComponent } from './usuarioroles/usuariorolesapps.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    InicioComponent,
    FormularioComponent,
    NormasComponent,
    MenuComponent,
    CabeceraComponent,
    ErrorComponent,
    PerfilComponent,
    FormularioNormasComponent,
    FormularioNormasPenalComponent,
    InventarioNormasComponent,
    FormularioBloqueComponent,
    FormularioAreaComponent,
    FormularioModuloComponent,
    FormularioPermisosComponent,
    InventarioNormasPenalComponent,
    FormularioBloquePenalComponent,
    FormularioAreaPenalComponent,
    FormularioModuloPenalComponent,
    FormularioPermisosPenalComponent,
    EvidenciasComponent,
    DataFilterPipe,
    DragDropComponent,
    FormularioEvidenciasComponent,
    FormularioEvidenciasPenalComponent,
    CuestionarioComponent,
    CuestionariosComponent,
    CuestionarioFullComponent,
    FormularioRespuestasComponent,
    PreguntaComponent,
    RespuestaComponent,
    EvidenciasINComponent,
    EvidenciasVistaComponent,
    ModalEvidenciasComponent,
    ModalPreguntasComponent,
    ModalDocumentoComponent,
    BreadcrumbComponent,
    UsuariosComponent,
    UsuarioComponent,
    EmpresaComponent,
    EmpresasComponent,
    CentroDeTrabajoComponent,
    CentrosDeTrabajoComponent,
    LicenciaComponent,
    LicenciasComponent,
    ModalusuariosctComponent,
    SubidaDeImagenes,    
    FormularioNormasMaestrasComponent,
    ModalModulosAfectadosComponent,
    ModalNormasMaestrasComponent,
    ModalEvidenciasMaestrasComponent,
    FormularioEvidenciasMaestrasComponent,
    ActividadesComponent,
    FormularioActividadesComponent,
    FormularioInstalacionesComponent,
    InstalacionesComponent,
    ModalEvidenciasAfectaPersonalComponent,
    FormularioEquiposComponent,
    ModalEnlaceNormasComponent,
    EquiposComponent,
    TipoCentrosComponent,
    FormularioTipoCentrosComponent,
    FormularioEvidenciasTipoCentrosComponent,
    TextospredefinidosComponent,
    FormulariotextosComponent,
    ModalevidenciainfoComponent,
    HistorialnormasaccionesComponent,
    ModaladminusuariosctsComponent,
    ModalevidenciasempresasComponent,
    ModalmoverevidenciaComponent,
    ModalcomponentComponent,
    ModalmovermoduloComponent,
    EvidenciafiltrosComponent,
    NormafiltrosComponent,
    EvidenciasequitativasComponent,
    ModalnormasempresasafectadasComponent,
    ModalformularioareaComponent,
    UsuariorolesComponent,
    FormulariousuariorolesComponent,
    UsuariorolesappsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    routing,
    ReactiveFormsModule,
    DataTableModule,
    CalendarModule,
    FileUploadModule,
    ConfirmDialogModule,
    //TooltipModule.forRoot(),
    TooltipModule,
    ModalModule.forRoot(),
    ImageCropperModule,
    DragulaModule.forRoot(),
    BrowserAnimationsModule,
    Select2Module,
    CKEditorModule
  ],
  providers: [
        {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    UsuariosService,
    AutentificacionService,
    SeguridadService,
    MenuService,
    GlobalEventsManager,
    NormasService,
    EvidenciasService,
    CuestionarioService,
    EmpresasService,
    CentrosDeTrabajoService,
    LicenciasService,
    ConfirmationService,
    TextospredefinidosService,
    TiendaService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts